import React, { useState, useEffect } from "react";
import Layout from '../components/Layout/Layout.js';
import { useParams, useNavigate } from "react-router-dom";
import "../styles/CategoryProductStyles.css";
import axios from "axios";
import { useCart } from '../context/cart.js';
import toast from 'react-hot-toast';
import QuickView from '../components/QuickView.js';

const CategoryProduct = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);
  const [cart, setCart] = useCart();
  const [quickViewProduct, setQuickViewProduct] = useState(null);

  useEffect(() => {
    if (params?.slug) getPrductsByCat();
    // eslint-disable-next-line
  }, [params?.slug]);

  const getPrductsByCat = async () => {
    try {
      const { data } = await axios.get(
        `/api/v1/products/product-category/${params.slug}`
      );
      setProducts(data?.products);
      setCategory(data?.category);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout title={`${category?.name || 'القسم'} - النخبة ستور`}>
      {/* Hero Banner */}
      <div className="categories-hero">
        <img src="/images/logo2.jpeg" alt="النخبة ستور" className="categories-hero-bg" />
        <div className="categories-hero-overlay">
          <h1>{category?.name}</h1>
          <p>تم العثور على {products?.length} منتج</p>
        </div>
      </div>

      <div className="container" style={{paddingTop: '40px', paddingBottom: '60px'}}>
        <h2 className='text-center section-heading' style={{marginTop: 0}}>
          <span className="heading-line"></span>
          منتجات {category?.name}
          <span className="heading-line"></span>
        </h2>
        <div className="d-flex flex-wrap justify-content-center">
          {products?.map((p, index) => (
            <div className="card product-card m-2" key={p._id} style={{animationDelay: `${index * 0.08}s`}}>
              <div className="card-img-wrapper">
                <button className="qv-trigger" type="button" aria-label="عرض سريع" onClick={() => setQuickViewProduct(p)} title="عرض سريع">👁</button>
                <img
                  src={`/api/v1/products/product-photo/${p._id}`}
                  className="card-img-top"
                  alt={p.name}
                  loading="lazy"
                  onClick={() => setQuickViewProduct(p)}
                  style={{cursor:'pointer'}}
                />
              </div>
              <div className="card-body">
                <h5 className="card-title">{p.name}</h5>
                <h5 className="card-title card-price">
                  {p.price.toLocaleString("ar-IQ")} د.ع
                </h5>
              </div>
              <p className="card-text">
                {p.description.substring(0, 60)}...
              </p>
              <div className="card-name-price">
                <button
                  className="btn btn-glass ms-1"
                  onClick={() => setQuickViewProduct(p)}
                >
                  التفاصيل
                </button>
                <button
                  className="btn btn-gold-shimmer ms-1"
                  onClick={() => {
                    setCart([...cart, p]);
                    localStorage.setItem("cart", JSON.stringify([...cart, p]));
                    toast.success("تمت الإضافة إلى السلة");
                  }}
                >
                  أضف إلى السلة
                </button>
              </div>
            </div>
          ))}
        </div>

        {products?.length === 0 && (
          <div className="empty-state">
            <div className="empty-state-icon">📱</div>
            <h4>لا توجد منتجات في هذا القسم</h4>
            <p>يرجى المحاولة لاحقاً</p>
          </div>
        )}
      </div>
      {quickViewProduct && (
        <QuickView product={quickViewProduct} onClose={() => setQuickViewProduct(null)} />
      )}
    </Layout>
  );
};

export default CategoryProduct;
